import * as React from "react";
import type { SVGProps } from "react";
const SvgEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="empty_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zM353.835 353.835a42.667 42.667 0 0 1 60.33 0L512 451.669l97.835-97.834a42.667 42.667 0 1 1 60.33 60.33L572.331 512l97.834 97.835a42.667 42.667 0 0 1-60.33 60.33L512 572.331l-97.835 97.834a42.667 42.667 0 0 1-60.33-60.33L451.669 512l-97.834-97.835a42.667 42.667 0 0 1 0-60.33z"
    />
  </svg>
);
export default SvgEmptyIcon;
